import { render, staticRenderFns } from "./PriceWorkflowDashboardPagination.vue?vue&type=template&id=796eb852&scoped=true&"
import script from "./PriceWorkflowDashboardPagination.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowDashboardPagination.vue?vue&type=script&lang=js&"
import style0 from "./PriceWorkflowDashboardPagination.vue?vue&type=style&index=0&id=796eb852&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796eb852",
  null
  
)

export default component.exports